"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Clock = function Clock(props) {
  return _react2["default"].createElement("svg", (0, _extends3["default"])({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _react2["default"].createElement("path", {
    className: "fill",
    d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm.6-12.273C8.6 3.326 8.242 3 7.8 3c-.442 0-.8.326-.8.727v4.364c0 .193.084.378.234.514l2.4 2.182a.858.858 0 0 0 1.132 0 .681.681 0 0 0 0-1.029L8.6 7.79V3.727z"
  }));
};

exports["default"] = Clock;